/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState, useContext } from "react";
import { useParams, useLocation } from 'react-router-dom';
import { Card, CardContent, Typography, Grid, Box, makeStyles, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, RadioGroup, FormControlLabel, Radio, MenuItem, Select, FormControl, InputLabel, IconButton, InputAdornment, List, ListItem, Paper, Badge } from '@material-ui/core';
import AuthCheckComponent from '../../Layouts/Token';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import AuthApi from '../../Services/Authapi';
import Breadcrumb from '../../Layouts/Breadcrumb';
import TableComponent from '../../Layouts/TableComponent';
import swal from 'sweetalert';
import { Tabs, Tab } from "@mui/material";
import TablePagination from "@material-ui/core/TablePagination";
import { DataGrid, GridPagination } from '@mui/x-data-grid';
import SearchIcon from '@material-ui/icons/Search';
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { FormLabel } from '@material-ui/core';
import ClearIcon from "@material-ui/icons/Clear";
import FilterListIcon from "@material-ui/icons/FilterList";
import CloseIcon from "@material-ui/icons/Close";
import PersonIcon from '@material-ui/icons/Person';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import BusinessIcon from '@material-ui/icons/Business';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import CakeIcon from '@material-ui/icons/Cake';
import WcIcon from '@material-ui/icons/Wc';
import SchoolIcon from '@material-ui/icons/School';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import DateRangeIcon from '@material-ui/icons/DateRange';
import WorkIcon from '@material-ui/icons/Work';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import "./user.css"
import "../Leaves/Leave.css";
import Tooltip from "@material-ui/core/Tooltip";
import FontAwesomeIconComponent from "../../Layouts/FontAwesomeIconComponent";
import { useHistory } from "react-router-dom";
import ProfileCompletionCircle from '../../Layouts/ProfileCompletionCircle';
import TooltipCell from '../../TooltipCell';
import defaultAvatar from '../../../Images/person.jpg';
import { ThemeContext } from '../../../ThemeContext';
import CommonTablePaginationActions, {
  COMMON_PAGINATION_CLASS,
  commonPaginationSelectProps,
  getCommonPaginationStyle,
} from '../../Common/commonPagination';
import PageLoader from '../../Layouts/PageLoader';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';



const getContrastYIQ = (hexcolor) => {
  if (!hexcolor) return 'black';
  // If hexcolor is something like "#000000", convert to rgb
  let r, g, b;
  if (hexcolor.startsWith('#')) {
    const hex = hexcolor.replace('#', '');
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else {
      r = parseInt(hex.substr(0, 2), 16);
      g = parseInt(hex.substr(2, 2), 16);
      b = parseInt(hex.substr(4, 2), 16);
    }
  } else if (hexcolor.startsWith('rgb')) {
    const rgb = hexcolor.match(/\d+/g);
    r = parseInt(rgb[0]);
    g = parseInt(rgb[1]);
    b = parseInt(rgb[2]);
  } else {
    return 'black';
  }
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 128) ? 'black' : 'white';
};

const formatDurationText = (value) => {
  if (!value || typeof value !== 'string' || value === '-' || value.toLowerCase() === 'n/a') return value;
  return value
    .replace(/\bhours?\b/gi, 'Hr')
    .replace(/\bminutes?\b/gi, 'Min')
    .replace(/\bhrs?\b/gi, 'Hr')
    .replace(/\bmins?\b/gi, 'Min');
};

const parseDurationToMinutes = (value) => {
  if (!value || typeof value !== 'string') return 0;

  const normalizedValue = value.toLowerCase().trim();
  if (!normalizedValue || normalizedValue === '-' || normalizedValue === 'n/a') return 0;

  let totalMinutes = 0;
  const hourMatch = normalizedValue.match(/(\d+)\s*(hour|hours|hr|hrs)/i);
  const minuteMatch = normalizedValue.match(/(\d+)\s*(minute|minutes|min|mins)/i);

  if (hourMatch) {
    totalMinutes += Number(hourMatch[1]) * 60;
  }

  if (minuteMatch) {
    totalMinutes += Number(minuteMatch[1]);
  }

  return totalMinutes;
};

const formatMinutesToDuration = (minutes) => {
  const totalMinutes = Number(minutes) || 0;
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;

  return `${hours}h ${remainingMinutes}m`;
};

const useStyles = makeStyles((theme) => ({
  profileCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 16,
    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.05)',
    padding: theme.spacing(3),
    textAlign: 'center',
    position: 'sticky',
    top: theme.spacing(10),
    border: `1px solid ${theme.palette.type === 'dark' ? 'var(--hrms-field-dark-border, #4b97ea)' : 'var(--hrms-field-border-soft, #d7e8fb)'}`,
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 8px 25px 0 rgba(0,0,0,0.1)',
      borderColor: theme.palette.type === 'dark'
        ? 'var(--hrms-field-dark-border, #4b97ea)'
        : 'var(--hrms-field-border-soft, #d7e8fb)',
    },
  },
  detailsCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 16,
    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.05)',
    padding: theme.spacing(4),
    border: `1px solid ${theme.palette.type === 'dark' ? 'var(--hrms-field-dark-border, #4b97ea)' : 'var(--hrms-field-border-soft, #d7e8fb)'}`,
  },
  profilePhoto: {
    width: '120px',
    height: '120px',
    border: `4px solid ${theme.palette.background.paper}`,
    boxShadow: theme.shadows[3],
    borderRadius: '50%',
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    objectFit: 'cover',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? 'rgba(75, 151, 234, 0.45)' : 'var(--hrms-field-border-soft, #d7e8fb)'}`,
    paddingBottom: theme.spacing(1.5),
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: '1.25rem',
    color: theme.palette.type === 'dark' ? 'var(--hrms-primary-blue-end, #036dda)' : '#111111',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  sectionIcon: {
    color: 'var(--hrms-primary-blue-end, #036dda)',
    fontSize: '1.5rem',
  },
  infoItem: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#fbfdff',
    border: theme.palette.type === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.18)'
      : '1px solid var(--hrms-field-border-soft, #d7e8fb)',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // Push label and value to opposite sides
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.06)' : '#f3f9ff',
      borderColor: theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.18)'
        : 'var(--hrms-field-border-soft, #d7e8fb)',
      transform: 'translateY(-2px)',
    },
  },
  infoLabel: {
    fontWeight: 700,
    color: 'var(--hrms-primary-blue-end, #036dda)',
    fontSize: '0.8rem', // Slightly smaller to save space
    marginBottom: 0,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    minWidth: '140px', // Reduced width to give more space to value
  },
  labelIcon: {
    fontSize: '1.2rem',
    color: 'var(--hrms-primary-blue-end, #036dda)',
  },
  infoValue: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    fontSize: '0.9rem', // Reduced font size to prevent wrapping
    wordBreak: 'break-word',
    lineHeight: 1.5,
    textAlign: 'right',
    flex: 1,
    paddingLeft: theme.spacing(2),
  },
  editButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: '6px 16px',
    boxShadow: 'none',
    border: '1px solid var(--hrms-primary-blue-end, #036dda)',
    color: 'var(--hrms-primary-blue-end, #036dda)',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      backgroundColor: 'rgba(27, 111, 209, 0.08)',
    },
    [theme.breakpoints.up('sm')]: {
      borderColor: 'var(--hrms-primary-blue-end, #036dda)',
      color: 'var(--hrms-primary-blue-end, #036dda)',
    }
  },
  socialIcon: {
    fontSize: 40,
    margin: theme.spacing(1),
  },
  container: {
    padding: theme.spacing(3),
  },
  cardContent: {
    padding: theme.spacing(0),
  },
  appBar: {
    marginBottom: theme.spacing(3),
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  actionButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: '8px 20px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
      transform: 'translateY(-1px)',
    },
  },
  tabRoot: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    marginRight: theme.spacing(4),
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main,
      opacity: 1,
    },
    '&$tabSelected': {
      color: theme.palette.primary.main,
    },
    '&:focus': {
      color: theme.palette.primary.main,
    },
  },
  tabSelected: {},
  dialogTitle: {
    background: 'linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)',
    color: theme.palette.common.white,
    padding: theme.spacing(2, 3),
    '& h2': {
      fontSize: '1.25rem',
      fontWeight: 700,
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.type === 'dark' ? 'rgba(75, 151, 234, 0.45)' : 'var(--hrms-field-border-soft, #d7e8fb)'}`,
  },
  customTextField: {
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#f8f9fa',
      '& fieldset': {
        borderColor: 'transparent',
        borderWidth: 1,
      },
      '&:hover fieldset': {
        borderColor: 'var(--hrms-field-border-hover, #036dda)',
        borderWidth: 1,
      },
      '&.Mui-focused fieldset': {
        borderColor: 'var(--hrms-field-border-hover, #036dda)',
        borderWidth: 1,
      },
    },
    '& .MuiInputLabel-root': {
      color: 'var(--hrms-primary-blue-end, #036dda)',
      fontWeight: 700,
      textTransform: 'uppercase',
      fontSize: '0.75rem',
      letterSpacing: '0.5px',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'var(--hrms-primary-blue-end, #036dda)',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
      borderRadius: 12,
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      color: 'var(--hrms-primary-blue-end, #036dda) !important',
    },
    '& .MuiFormLabel-root': {
      color: 'var(--hrms-primary-blue-end, #036dda)',
    },
    '& .MuiSvgIcon-root': {
      color: 'var(--hrms-primary-blue-end, #036dda)',
    },
  },
  qualificationSelect: {
    '& .MuiSelect-select': {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingRight: theme.spacing(4),
    },
  },
  uploadArea: {
    width: '100%',
    minHeight: '100px',
    border: `2px dashed ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'var(--hrms-primary-blue-border, #1864bc)'}`,
    borderRadius: '1rem',
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#f8fafc',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#f1f5f9',
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.4)' : 'var(--hrms-primary-blue-end, #036dda)',
    },
  },
  uploadAreaActive: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.15)' : '#ffffff',
    borderColor: 'var(--hrms-primary-blue-end, #036dda)',
    boxShadow: `0 0 0 4px ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(27, 111, 209, 0.12)'}`,
  },
  fileInput: {
    display: 'none',
  },
}));

const getFieldDisplayName = (fieldName) => {
  const fieldMappings = {
    "firstName": "First Name",
    "lastName": "Last Name",
    "photo": "Profile Photo",
    "dob": "Date of Birth",
    "doj": "Date of Joining",
    "bankName": "Bank Name",
    "bankAccNo": "Bank Account Number",
    "designation": "Designation",
    "email": "Email",
    "personal_email": "Personal Email",
    "mobileNo": "Mobile Number",
    "last_organization": "Last Organization",
    "location": "Location",
    "qualification": "Qualification"
  };
  return fieldMappings[fieldName] || fieldName;
};

const UserDetails = (props) => {
  const classes = useStyles();
  const themeContext = useContext(ThemeContext);
  const darkMode = themeContext ? themeContext.darkMode : false;
  const { users = [], authToken, authUser } = props;
  const [userimg1, setuserimg] = useState([]);
  const [userDetails, setuserDetails] = useState("");
  const { userId: encodedUserId } = useParams();
  const decodedString = atob(encodedUserId);
  const userId = decodedString.split('-')[0];
  const location = useLocation();
  const [openEditPersonal, setOpenEditPersonal] = useState(false);
  const [openEditBank, setOpenEditBank] = useState(false);
  const [openEditOffice, setOpenEditOffice] = useState(false);
  const [qualifications, setQualifications] = useState([]);
  const [qualificationsLoaded, setQualificationsLoaded] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [photo, setPhoto] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const [leaveMonthYear, setLeaveMonthYear] = useState(new Date());
  const history = useHistory()
  const [selectedMonthYear, setSelectedMonthYear] = useState(new Date().toISOString().slice(0, 7));
  const [salary, setSalary] = useState([]);
  const [salarySourceData, setSalarySourceData] = useState([]);
  const [slip, setslip] = React.useState([]);
  const [Pdf, setPdf] = React.useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leavePage, setLeavePage] = useState(0);
  const [salaryPage, setSalaryPage] = useState(0);
  const [leaveBalancePage, setLeaveBalancePage] = useState(0);
  const [attendancePage, setAttendancePage] = useState(0);
  const [totalDurationTime, setTotalDurationTime] = useState([]);
  const [attendanceSourceData, setAttendanceSourceData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionData, setSuggestionData] = useState([]);
  const [searchSalaryQuery, setSearchSalaryQuery] = useState("");
  const [Salarysuggestions, setSalarySuggestions] = useState([]);
  const [SalaryshowSuggestions, setSalaryShowSuggestions] = useState(false);
  const [SalarysuggestionData, setSalarySuggestionData] = useState([]);
  const [searchLeaveQuery, setSearchLeaveQuery] = useState("");
  const [Leavesuggestions, setLeaveSuggestions] = useState([]);
  const [LeaveshowSuggestions, setLeaveShowSuggestions] = useState(false);
  const [LeavesuggestionData, setLeaveSuggestionData] = useState([]);
  const [timeRange, setTimeRange] = useState("today");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [modalTimeRange, setModalTimeRange] = useState("today");
  const [modalStartDate, setModalStartDate] = useState("");
  const [modalEndDate, setModalEndDate] = useState("");
  const [editPersonalInfo, setEditPersonalInfo] = useState({
    firstName: '',
    lastName: '',
    email: '',
    personal_email: '',
    dob: '',
    gender: '',
    qualification: '',
    lastOrganization: '',
    mobileNo: ''
  });
  const [editBankInfo, setEditBankInfo] = useState({
    bankName: '',
    bankAccNo: ''
  });
  const [editOfficeInfo, setEditOfficeInfo] = useState({
    doj: '',
    designation: ''
  });
  const [leaveData, setLeaveData] = useState([]);
  const [leaveSourceData, setLeaveSourceData] = useState([]);
  const [statusColors, setStatusColors] = useState({});
  const [leaveBalanceData, setLeaveBalanceData] = useState([]);
  const [leaveBalanceLoading, setLeaveBalanceLoading] = useState(false);
  const [leaveBalanceMonth, setLeaveBalanceMonth] = useState('All');
  const [leaveBalanceYear, setLeaveBalanceYear] = useState('All');
  const [leaveBalanceMonthYear, setLeaveBalanceMonthYear] = useState('');
  const [leaveBalanceSummary, setLeaveBalanceSummary] = useState(null);
  const [searchLeaveBalanceQuery, setSearchLeaveBalanceQuery] = useState("");
  const [LeaveBalancesuggestions, setLeaveBalanceSuggestions] = useState([]);
  const [LeaveBalanceshowSuggestions, setLeaveBalanceShowSuggestions] = useState(false);
  const [LeaveBalancesuggestionData] = useState([]);
  const [leaveSummaryDialog, setLeaveSummaryDialog] = useState({
    open: false,
    title: '',
    details: [],
  });
  const [dragActive, setDragActive] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);


  // Authorization guard: Only allow Super Admins or the profile owner
  useEffect(() => {
    try {
      const storedUserRaw = typeof window !== 'undefined' ? localStorage.getItem('user') : null;
      const storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : null;
      const currentUserRoles = (storedUser && storedUser.roles) || (authUser && authUser.roles) || [];
      const isSuperAdmin = Array.isArray(currentUserRoles) && currentUserRoles.some((r) => {
        if (!r) return false;
        if (typeof r === 'string') return r.toLowerCase() === 'super admin';
        if (typeof r === 'object' && r.name) return String(r.name).toLowerCase() === 'super admin';
        return false;
      });
      const isOwnProfile = storedUser && String(storedUser.id) === String(userId);
      if (!isSuperAdmin && !isOwnProfile) {
        swal({
          title: 'Access denied',
          text: 'You are not authorized to view this user profile.',
          icon: 'error',
        }).then(() => {
          history.replace('/dashboard');
        });
      }
    } catch (e) {
      // In case of parsing errors, fail closed
      history.replace('/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const userimg = async () => {
    if (userId) {
      let users = await AuthApi.userimgid(userId);
      setuserimg(users);
    }
  };

  const fetchUserDetails = async () => {
    if (userId) {
      let users = await AuthApi.singleUser(userId);
      setuserDetails(users.data);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await AuthApi.Departmentshow1();
      if (response && response.data) {
        setDepartments(response.data);
      } else {
        setDepartments([]);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setDepartments([]);
    }
  };

  const getValidatedDepartment = (department) => {
    if (!department) return "-";
    const hasDepartment = departments.some(
      (item) => String(item.department || "").trim() === String(department).trim()
    );
    return hasDepartment ? department : "-";
  };

  useEffect(() => {
    const loadInitialData = async () => {
      setPageLoading(true);
      try {
        await Promise.all([userimg(), fetchUserDetails(), getQualificationData(), fetchDepartments()]);
      } finally {
        setPageLoading(false);
      }
    };

    loadInitialData();
  }, [userId]);

  useEffect(() => {
    if (userDetails) {
      setEditPersonalInfo({
        firstName: userDetails.firstName || '',
        lastName: userDetails.lastName || '',
        email: userDetails.email || '',
        personal_email: userDetails.personal_email || '', // Added personal_email
        dob: userDetails.dob || '',
        gender: userDetails.gender || '',
        qualification: userDetails.qualification || '',
        last_organization: userDetails.last_organization || '',
        mobileNo: userDetails.mobileNo || '',
        photo: photo,
        roleName: userDetails.roleName,
        uploadedImgName: userDetails.uploadedImgName,
        salary: userDetails.salary,
        bankName: userDetails.bankName,
        bankAccNo: userDetails.bankAccNo,
        doj: userDetails.doj,
        location: userDetails.location,
        department: userDetails.department,
        designation: userDetails.designation,
        password: userDetails.password,
        user_id: userDetails.user_id,
        allowed_ip: userDetails.allowed_ip,
      });

      setEditBankInfo({
        bankName: userDetails.bankName || '',
        bankAccNo: userDetails.bankAccNo || '',
        firstName: userDetails.firstName || '',
        lastName: userDetails.lastName || '',
        email: userDetails.email || '',
        personal_email: userDetails.personal_email || '',
        dob: userDetails.dob || '',
        gender: userDetails.gender || '',
        qualification: userDetails.qualification || '',
        last_organization: userDetails.last_organization || '',
        mobileNo: userDetails.mobileNo || '',
        photo: photo,
        roleName: userDetails.roleName,
        uploadedImgName: userDetails.uploadedImgName,
        salary: userDetails.salary,
        doj: userDetails.doj,
        location: userDetails.location,
        department: userDetails.department,
        designation: userDetails.designation,
        password: userDetails.password,
        user_id: userDetails.user_id,
        allowed_ip: userDetails.allowed_ip,
      });

      setEditOfficeInfo({
        doj: userDetails.doj || '',
        designation: userDetails.designation || '',
        bankName: userDetails.bankName,
        bankAccNo: userDetails.bankAccNo,
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        email: userDetails.email,
        personal_email: userDetails.personal_email || '',
        dob: userDetails.dob,
        gender: userDetails.gender,
        qualification: userDetails.qualification,
        last_organization: userDetails.last_organization,
        mobileNo: userDetails.mobileNo,
        photo: photo,
        roleName: userDetails.roleName,
        uploadedImgName: userDetails.uploadedImgName,
        salary: userDetails.salary,
        location: userDetails.location,
        department: userDetails.department,
        password: userDetails.password,
        user_id: userDetails.user_id,
        allowed_ip: userDetails.allowed_ip,
      });

      setPhoto(userDetails.photo || '');
    }
  }, [userDetails]);

  const handleEditOpen = (section) => {
    switch (section) {
      case 'personal':
        setOpenEditPersonal(true);
        break;
      case 'bank':
        setOpenEditBank(true);
        break;
      case 'office':
        setOpenEditOffice(true);
        break;
      default:
        break;
    }
  };

  const handleEditClose = (section) => {
    switch (section) {
      case 'personal':
        setOpenEditPersonal(false);
        break;
      case 'bank':
        setOpenEditBank(false);
        break;
      case 'office':
        setOpenEditOffice(false);
        break;
      default:
        break;
    }
  };

  const handleUpdateUser = async (section) => {
    if (section === 'personal') {
      if (editPersonalInfo.mobileNo && editPersonalInfo.mobileNo.length !== 10) {
        swal({
          title: "Invalid Input",
          text: "Phone number must be exactly 10 digits.",
          icon: "error",
          button: "Ok",
        });
        return;
      }
    }

    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      width: "10%",
      content: createSwalLoaderNode()
    });
    try {
      let updateData = {};
      switch (section) {
        case 'personal':
          updateData = {
            ...editPersonalInfo,
            dob: formatDate(editPersonalInfo.dob),
            photo
          };
          break;
        case 'bank':
          updateData = {
            ...editBankInfo,
            dob: formatDate(editBankInfo.dob),
            photo
          };
          break;
        case 'office':
          updateData = {
            ...editOfficeInfo,
            dob: formatDate(editOfficeInfo.dob),
            photo
          };
          break;
        default:
          break;
      }
      let status = await AuthApi.updateUser(updateData, userId);
      swal.close();
      if (status && status.status === true) {
        swal("Success", "Personal info updated successfully", "success");
        fetchUserDetails();
        userimg();
        handleEditClose(section);
      } else {
        swal("Error", status && status.message ? status.message : "Failed to update user data", "error");
      }
    } catch (error) {
      console.error('Error updating user data:', error);
    }
  };

  function formatDate(dob) {
    if (!dob) return '';
    const parts = dob.split("-");
    return `${parts[0]}-${parts[1]}-${parts[2]}`;
  }
  const month = leaveMonthYear.getMonth() + 1;
  const year = leaveMonthYear.getFullYear();
  useEffect(() => {
    const month = leaveMonthYear.getMonth() + 1;
    const year = leaveMonthYear.getFullYear();
    userreportAttendance(userId, timeRange);
    fetchLeaveTickets(userId, month, year);
  }, [userId, month, year, timeRange, leaveMonthYear]);

  useEffect(() => {
    AuthApi.getStatusColors().then((response) => {
      if (response && response.status && response.data) {
        const fetchedColors = response.data;
        const defaultColors = {
          'Present': '#1dbb11',
          'Absent': '#ff5c5c',
          'Half day': '#0acdb6',
          'Left Early': '#065112',
          'Late': '#9d744d',
          'Week Off': '#0f38db',
          'Holiday': '#ca04cd',
          'Short Hours': '#ffffff'
        };

        Object.keys(defaultColors).forEach(key => {
          if (!fetchedColors[key] || (typeof fetchedColors[key] === 'string' && (fetchedColors[key].toLowerCase() === '#ffffff' || fetchedColors[key].toLowerCase() === '#fff'))) {
            fetchedColors[key] = defaultColors[key];
          }
        });

        if (fetchedColors['Comes Late'] && !fetchedColors['Late']) {
          fetchedColors['Late'] = fetchedColors['Comes Late'];
        }
        setStatusColors(fetchedColors);
      } else {
        setStatusColors({});
      }
    });
  }, []);

  const getQualificationData = async () => {
    try {
      const response = await AuthApi.getQulification();
      if (response && response.data) {
        setQualifications(response.data);
      }
    } catch (error) {
      console.error('Error fetching qualification data:', error);
    } finally {
      setQualificationsLoaded(true);
    }
  };

  const handlePersonalInfoChange = (e) => {
    const { name, value } = e.target;
    if (name === 'dob') {
      const [year, month, day] = value.split('-');
      const formattedDate = `${day}-${month}-${year}`;
      setEditPersonalInfo((prev) => ({ ...prev, [name]: formattedDate }));
    } else if (name === 'mobileNo') {
      if (/^\d*$/.test(value) && value.length <= 10) {
        setEditPersonalInfo((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setEditPersonalInfo((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleBankInfoChange = (e) => {
    const { name, value } = e.target;
    setEditBankInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleOfficeInfoChange = (e) => {
    const { name, value } = e.target;
    setEditOfficeInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  function formatDate(dateString) {
    if (!dateString) return '';
    const parts = dateString.split("-");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
  }

  const handleTimeRangeChange = (event) => {
    setTimeRange(event.target.value);
    userreportAttendance(userId, event.target.value);
  };

  const openFilterModal = () => {
    setShowFilterModal(true);
    setModalTimeRange(timeRange);
    setModalStartDate(startDate);
    setModalEndDate(endDate);
  };

  const applyFilters = () => {
    setTimeRange(modalTimeRange);
    setStartDate(modalStartDate);
    setEndDate(modalEndDate);
    setShowFilterModal(false);
    setAttendancePage(0);

    if (modalStartDate && modalEndDate) {
      handleDateRangeChange(modalStartDate, modalEndDate);
    } else {
      userreportAttendance(userId, modalTimeRange);
    }
  };

  const clearFilters = () => {
    setTimeRange("today");
    setStartDate("");
    setEndDate("");
    setModalTimeRange("today");
    setModalStartDate("");
    setModalEndDate("");
    setShowFilterModal(false);
    setAttendancePage(0);
    userreportAttendance(userId, "today");
  };

  const handleDateRangeChange = async (startDate, endDate) => {
    if (startDate && endDate) {
      const [startYear, startMonth, startDay] = startDate.split("-");
      const [endYear, endMonth, endDay] = endDate.split("-");
      const response = await AuthApi.getUserReportByDateRange(userId, startDay, startMonth, startYear, endDay, endMonth, endYear);
      if (response && response.data) {
        const formattedData = response.data.map((item, index) => ({
          id: index,
          name: item.user_name,
          firstName: item.firstname,
          status: item.status,
          date: item.date,
          lastouttime: item.last_out_time,
          firstintime: item.first_in_time,
          breaks: item.breaks,
          breakduration: item.break_duration,
          totalduration: item.total_duration,
        }));
        setAttendanceSourceData(formattedData);
        setOriginalData(formattedData);
        setTotalDurationTime(filterRowsByQuery(formattedData, searchQuery));
      } else {
        setAttendanceSourceData([]);
        setTotalDurationTime([]);
      }
    }
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);
    handleDateRangeChange(startDate, newEndDate);
  };

  const userreportAttendance = async (userId, timeRange) => {
    try {
      const response = await AuthApi.userreportAttendance(userId, timeRange);
      const data = response.data;
      const firstNames = data.map(item => item.firstname);
      const uniqueFirstNames = [...new Set(firstNames)];
      setSuggestionData(uniqueFirstNames);
      if (response && response.data) {
        const formattedData = response.data.map((item, index) => ({
          id: index,
          name: item.user_name,
          firstName: item.firstname,
          status: item.status,
          date: item.date,
          lastouttime: item.last_out_time,
          firstintime: item.first_in_time,
          breaks: item.breaks,
          breakduration: item.break_duration,
          totalduration: item.total_duration,
        }));
        setAttendanceSourceData(formattedData);
        setOriginalData(formattedData);
        setTotalDurationTime(filterRowsByQuery(formattedData, searchQuery));
      } else {
        setAttendanceSourceData([]);
        setTotalDurationTime([]);
      }
    } catch (error) {
      console.error('Error fetching attendance data:', error);
      setAttendanceSourceData([]);
      setTotalDurationTime([]);
    }
  };

  const filterRowsByQuery = (rows, query) => {
    const normalizedQuery = (query || "").toLowerCase().trim();

    if (!normalizedQuery) {
      return rows;
    }

    return rows.filter((item) =>
      Object.values(item).some((value) => {
        if (value != null) {
          return value.toString().toLowerCase().includes(normalizedQuery);
        }

        return false;
      })
    );
  };

  const applyAttendanceSearch = (query) => {
    setTotalDurationTime(filterRowsByQuery(attendanceSourceData, query));
  };

  const applySalarySearch = (query) => {
    setSalary(filterRowsByQuery(salarySourceData, query));
  };

  const applyLeaveSearch = (query) => {
    setLeaveData(filterRowsByQuery(leaveSourceData, query));
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredSuggestions = suggestionData.filter(suggestion =>
        typeof suggestion === 'string' && suggestion.toLowerCase().includes(query.toLowerCase())
      );
      setSuggestions(filteredSuggestions);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }

    applyAttendanceSearch(query);
    setAttendancePage(0);
  };

  const handleSearch = () => {
    setShowSuggestions(false);
    applyAttendanceSearch(searchQuery);
    setAttendancePage(0);
  };

  const handleSuggestionClick = (suggestion) => {
    const nextQuery = suggestion || "";
    setSearchQuery(nextQuery);
    setSuggestions([]);
    setShowSuggestions(false);
    applyAttendanceSearch(nextQuery);
    setAttendancePage(0);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setSuggestions([]);
    setShowSuggestions(false);
    setTotalDurationTime(attendanceSourceData);
    setAttendancePage(0);
  };

  const totalWorkingHours = formatMinutesToDuration(
    totalDurationTime.reduce((sum, row) => sum + parseDurationToMinutes(row.totalduration), 0)
  );

  const handleSalarySearchChange = (e) => {
    const query = e.target.value;
    setSearchSalaryQuery(query);

    if (query) {
      const filteredSuggestions = SalarysuggestionData.filter(suggestion =>
        suggestion.toLowerCase().includes(query.toLowerCase())
      );
      setSalarySuggestions(filteredSuggestions);
      setSalaryShowSuggestions(true);
    } else {
      setSalarySuggestions([]);
      setSalaryShowSuggestions(false);
    }

    applySalarySearch(query);
    setSalaryPage(0);
  };

  const handleSalarySearch = () => {
    setSalaryShowSuggestions(false);
    applySalarySearch(searchSalaryQuery);
    setSalaryPage(0);
  };


  const handleSalarySuggestionClick = (suggestion) => {
    const nextQuery = suggestion || "";
    setSearchSalaryQuery(nextQuery);
    setSalaryShowSuggestions(false);
    setSalarySuggestions([]);
    applySalarySearch(nextQuery);
    setSalaryPage(0);
  };

  const handleSalaryClearSearch = () => {
    setSearchSalaryQuery('');
    setSalarySuggestions([]);
    setSalaryShowSuggestions(false);
    setSalary(salarySourceData);
    setSalaryPage(0);
  };


  const handleLeaveSearchChange = (e) => {
    const query = e.target.value;
    setSearchLeaveQuery(query);

    if (query) {
      const filteredSuggestions = LeavesuggestionData && LeavesuggestionData.filter(suggestion =>
        suggestion.toLowerCase().includes(query.toLowerCase())
      );
      setLeaveSuggestions(filteredSuggestions || []);
      setLeaveShowSuggestions(true);
    } else {
      setLeaveSuggestions([]);
      setLeaveShowSuggestions(false);
    }

    applyLeaveSearch(query);
    setLeavePage(0);
  };


  const handleLeaveSearch = async () => {
    setLeaveShowSuggestions(false);
    applyLeaveSearch(searchLeaveQuery);
    setLeavePage(0);
  };

  const handleLeaveSuggestionClick = (suggestion) => {
    const nextQuery = suggestion || "";
    setSearchLeaveQuery(nextQuery);
    setLeaveShowSuggestions(false);
    setLeaveSuggestions([]);
    applyLeaveSearch(nextQuery);
    setLeavePage(0);
  };

  const handleLeaveClearSearch = () => {
    setSearchQuery('');
    setSearchLeaveQuery('');
    setLeaveSuggestions([]);
    setLeaveShowSuggestions(false);
    setLeaveData(leaveSourceData);
    setLeavePage(0);
  };

  const handleLeaveBalanceSearchChange = (e) => {
    const query = e.target.value;
    setSearchLeaveBalanceQuery(query);
    if (query) {
      const filteredSuggestions = LeaveBalancesuggestionData.filter(suggestion =>
        suggestion.toLowerCase().includes(query.toLowerCase())
      );
      setLeaveBalanceSuggestions(filteredSuggestions);
      setLeaveBalanceShowSuggestions(true);
    } else {
      setLeaveBalanceSuggestions([]);
      setLeaveBalanceShowSuggestions(false);
    }
    setLeaveBalancePage(0);
  };

  const handleLeaveBalanceSearch = () => {
    setLeaveBalanceShowSuggestions(false);
    setLeaveBalancePage(0);
  };

  const handleLeaveBalanceClearSearch = () => {
    setSearchLeaveBalanceQuery('');
    setLeaveBalanceSuggestions([]);
    setLeaveBalanceShowSuggestions(false);
    setLeaveBalancePage(0);
  };

  const CustomFooter = () => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1 }}>
      <Box sx={{ ml: 1, fontSize: '14px', fontWeight: 500 }}>
        Total Working Hours: {totalWorkingHours}
      </Box>
      <GridPagination />
    </Box>
  );

  const attendanceHeaders = [
    { id: 'date', numeric: false, disablePadding: true, label: 'Date', sortable: true },
    { id: 'status', numeric: false, disablePadding: true, label: 'Status', sortable: true },
    { id: 'firstintime', numeric: false, disablePadding: true, label: 'First In Time', sortable: true },
    { id: 'lastouttime', numeric: false, disablePadding: true, label: 'Last Out Time', sortable: true },
    { id: 'totalduration', numeric: false, disablePadding: true, label: 'Total Duration', sortable: true },
    { id: 'breakduration', numeric: false, disablePadding: true, label: 'Break Duration', sortable: true },
    { id: 'breaks', numeric: false, disablePadding: true, label: 'Breaks', sortable: true },
  ];

  const leaveHeaders = [
    { id: 'emp_id', numeric: false, disablePadding: true, label: 'Employee ID', sortable: true },
    { id: 'firstName', numeric: false, disablePadding: true, label: 'Name', sortable: true },
    { id: 'leaveType', numeric: false, disablePadding: true, label: 'Leave Type', sortable: true },
    { id: 'ticket_mesasge', numeric: false, disablePadding: true, label: 'Ticket Mesasge', sortable: true },
    { id: 'date_range', numeric: false, disablePadding: true, label: 'Date Range', sortable: true },
    { id: 'no_of_days', numeric: false, disablePadding: true, label: 'No Of Days', sortable: true },
    { id: 'status', numeric: false, disablePadding: true, label: 'Status', sortable: true },
    { id: 'cancel_reason', numeric: false, disablePadding: true, label: 'Reason for Declined', sortable: true },
    { id: 'c_reason', numeric: false, disablePadding: true, label: 'Reason for Cancel', sortable: true },
    { id: 'created_at', numeric: false, disablePadding: true, label: 'Created At', sortable: true },
    { id: 'updated_at', numeric: false, disablePadding: true, label: 'Updated', sortable: true },
  ];

  const salaryHeaders = [
    { id: 'name', numeric: false, disablePadding: true, label: 'Employee ID', sortable: true },
    { id: 'firstName', numeric: false, disablePadding: true, label: 'Name', sortable: true },
    { id: 'BasicSalary', numeric: false, disablePadding: true, label: 'Basic Salary', sortable: true },
    { id: 'DA', numeric: false, disablePadding: true, label: 'DA', sortable: true },
    { id: 'HRA', numeric: false, disablePadding: true, label: 'HRA', sortable: true },
    { id: 'CA', numeric: false, disablePadding: true, label: 'CA', sortable: true },
    { id: 'Tax', numeric: false, disablePadding: true, label: 'Tax', sortable: true },
    { id: 'netSalary', numeric: false, disablePadding: true, label: 'Net Salary', sortable: true },
    { id: 'MonthYear', numeric: false, disablePadding: true, label: 'Month Year', sortable: true },
    { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false },
  ];

  const columns = [
    { field: 'date', headerName: 'Date', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const displayValue = params.value === 'Comes Late' ? 'Late' : params.value;
        const color = statusColors && statusColors[displayValue] ? statusColors[displayValue] : '#000000';
        return (
          <div
            style={{
              display: 'inline-block',
              backgroundColor: color,
              color: getContrastYIQ(color),
              padding: '4px 8px',
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '12px',
              fontFamily: 'Arial, sans-serif',
              minWidth: '90px',
              width: 'auto',
              textAlign: 'center',
            }}
          >
            {displayValue}
          </div>
        );
      }
    },
    { field: 'firstintime', headerName: 'First In Time', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'lastouttime', headerName: 'Last Out Time', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'totalduration',
      headerName: 'Total Duration',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {formatDurationText(params.value)}
          </div>
        );
      }
    },
    {
      field: 'breakduration',
      headerName: 'Break Duration',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {formatDurationText(params.value)}
          </div>
        );
      }
    },
    { field: 'breaks', headerName: 'Breaks', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
  ];

  const leaveColumns = [
    { field: 'emp_id', headerName: 'Employee ID', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'firstName', headerName: 'Name', flex: 1, headerClassName: 'header-red', align: 'left', headerAlign: 'left', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>{params.value}</div> },
    { field: 'leaveType', headerName: 'Leave Type', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'ticket_mesasge', headerName: 'Ticket Mesasge', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'date_range',
      headerName: 'Date Range',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const val = params.value || '';
        const parts = val.split(/\s+to\s+/i);
        if (parts.length === 2) {
          return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.2', padding: '10px 0' }}>
              <span style={{ whiteSpace: 'nowrap' }}>{parts[0]}</span>
              <span style={{ fontSize: '0.85em', opacity: 0.8, margin: '2px 0' }}>To</span>
              <span style={{ whiteSpace: 'nowrap' }}>{parts[1]}</span>
            </div>
          );
        }
        return <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{val}</div>;
      }
    },
    { field: 'no_of_days', headerName: 'No Of Days', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const displayValue = params.value === 'Comes Late' ? 'Late' : params.value;
        const color = statusColors && statusColors[displayValue] ? statusColors[displayValue] : '#e5e562ff';
        return (
          <div
            style={{
              display: 'inline-block',
              backgroundColor: color,
              color: getContrastYIQ(color),
              padding: '4px 8px',
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '12px',
              fontFamily: 'Arial, sans-serif',
              minWidth: '90px',
              width: 'auto',
              textAlign: 'center',
            }}
          >
            {displayValue}
          </div>
        );
      }
    },
    { field: 'cancel_reason', headerName: 'Reason for Declined', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'c_reason', headerName: 'Reason for Cancel', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'created_at',
      headerName: 'Created At',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const val = params.value || '';
        const parts = val.split(' ');
        return (
          <div style={{ lineHeight: '1.2', display: 'flex', flexDirection: 'column' }}>
            <span>{parts[0]}</span>
            <span style={{ fontSize: '0.85em', color: 'gray' }}>{parts.slice(1).join(' ')}</span>
          </div>
        );
      }
    },
    {
      field: 'updated_at',
      headerName: 'Updated',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const val = params.value || '';
        const parts = val.split(' ');
        return (
          <div style={{ lineHeight: '1.2', display: 'flex', flexDirection: 'column' }}>
            <span>{parts[0]}</span>
            <span style={{ fontSize: '0.85em', color: 'gray' }}>{parts.slice(1).join(' ')}</span>
          </div>
        );
      }
    },
  ];

  const fetchLeaveTickets = async (userId, month, year) => {
    try {
      const response = await AuthApi.leavetickets(userId, month, year);
      const data = response.data;
      const firstNames = data.map(item => item.firstName);
      const uniqueFirstNames = [...new Set(firstNames)];
      setLeaveSuggestionData(uniqueFirstNames);
      if (response && response.data) {
        setLeaveSourceData(response.data);
        setLeaveData(filterRowsByQuery(response.data, searchLeaveQuery));
        setOriginalData(response.data);
      } else {
        setLeaveSourceData([]);
        setLeaveData([]);
      }
      return response.data.data;
    } catch (error) {
      console.error("Error fetching leave tickets:", error);
      setLeaveSourceData([]);
      setLeaveData([]);
      setOriginalData([]);
    }
  };

  const handleMonthChange = (event) => {
    const date = new Date(event.target.value);
    setLeaveMonthYear(date);
    setLeavePage(0);
  };

  const openModal = async (user_id) => {
    try {
      const slip = await AuthApi.viewSalarySlip(user_id);
      if (slip) {
        setslip(slip)
      } else {
      }
      setPdf(true)
    } catch (error) {
    }
  };

  const downloadSlip = async (id) => {
    try {
      swal({
        title: "Salaries Downloading...",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        width: "10%",
        content: createSwalLoaderNode()
      });
      const slip = await AuthApi.getAllSalaryPdf(id);
      if (slip && slip.status === true) {
      }
      swal.close();
    } catch (error) {
      swal.close();
      console.error("Error downloading salary slip:", error);
      swal({
        title: "Error",
        text: "Failed to download salary slip. Please try again later.",
        icon: "error",
      });
    }
  }

  // const removeUser = async (id) => {
  //   swal({
  //     title: "Are you sure?",
  //     icon: "warning",
  //     buttons: ["Cancel", "Yes"],
  //   }).then(async (confirm) => {
  //     if (confirm) {
  //       let currentUser = await AuthApi.Salarydelete(id);
  //       if (currentUser && currentUser.status === true) {
  //         history.push("/dashboard");
  //       } else {
  //       }
  //     }
  //   });
  // }

  const salaryColumns = [
    { field: 'name', headerName: 'Employee ID', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'firstName', headerName: 'Name', flex: 1, headerClassName: 'header-red', align: 'left', headerAlign: 'left', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>{params.value}</div> },
    { field: 'BasicSalary', headerName: 'Basic Salary', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'DA', headerName: 'DA', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'HRA', headerName: 'HRA', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'CA', headerName: 'CA', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'Tax', headerName: 'Tax', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'netSalary', headerName: 'Net Salary', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'MonthYear', headerName: 'Month Year', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'actions', headerName: 'Actions', flex: 1, headerClassName: 'header-red', renderCell: (params) => (
        <>
          <Tooltip title="Show">
            <IconButton
              variant="contained"
              color="primary"
              style={{ padding: "4px" }}
              onClick={() => openModal(params.id)}
            >
              <FontAwesomeIconComponent
                classes="fa fa-eye"
                colorName="primary"
                fontSize={"small"}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download">
            <IconButton
              variant="contained"
              color="primary"
              style={{ padding: "4px" }}
              onClick={(id) => downloadSlip(params.id)}
            >
              <FontAwesomeIconComponent
                classes="fa fa-download"
                colorName="primary"
                fontSize={"small"}
              />
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Delete">
            <IconButton
              variant="contained"
              color="primary"
              style={{ padding: "4px" }}
              onClick={() => removeUser(params.id)}
            >
              <FontAwesomeIconComponent
                classes="fa fa-trash"
                colorName="primary"
                fontSize={"small"}
              />
            </IconButton>
          </Tooltip> */}
        </>
      )
    },
  ];

  const imgUpload = async (input) => {
    let file;
    if (input.target && input.target.files) {
      file = input.target.files[0];
    } else {
      file = input;
    }

    if (!file) return;

    const postData = new FormData();
    postData.append("file", file);
    try {
      let updateImg = await AuthApi.updateImg(postData);
      if (updateImg && updateImg.status === true) {
        setPhoto(updateImg.data.image_url);
        setEditPersonalInfo((prev) => ({
          ...prev,
          photo: updateImg.data.image_url,
          uploadedImgName: updateImg.data.image_name,
        }));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      imgUpload(e.dataTransfer.files[0]);
    }
  };

  const handleMonthYearChange = (event) => {
    setSelectedMonthYear(event.target.value);
    setSalaryPage(0);
  };


  const fetchSalaryData = async () => {
    const [year, month] = selectedMonthYear.split("-");
    try {
      const response = await AuthApi.alldatasalaryid(parseInt(month), year, userId);
      if (response && response.data) {
        const data = response.data;
        setSalarySourceData(data);
        setSalary(filterRowsByQuery(data, searchSalaryQuery));
        setOriginalData(data)
        const firstNames = data.map(item => item.firstName);
        const uniqueFirstNames = [...new Set(firstNames)];
        setSalarySuggestionData(uniqueFirstNames);
      } else {
        setSalarySourceData([]);
        setSalary([]);
      }
    } catch (error) {
      console.error("Error fetching salary data:", error);
      setSalarySourceData([]);
      setSalary([]);
      setOriginalData([]);
    }
  };
  useEffect(() => {
    const [year, month] = selectedMonthYear.split("-");
    fetchSalaryData(parseInt(month), year, userId);
  }, [selectedMonthYear, userId]);

  useEffect(() => {
    if (location.state && location.state.tab === "salaryInfo") {
      setTabIndex(3);
      if (location.state.salarySlipId) {
        openModal(location.state.salarySlipId);
      }
    }
  }, [location.state]);

  // Fetch leave balance data
  useEffect(() => {
    const fetchLeaveBalance = async () => {
      setLeaveBalanceLoading(true);
      try {
        const today = new Date();
        const [selectedYear, selectedMonth] = leaveBalanceMonthYear
          ? leaveBalanceMonthYear.split('-')
          : [String(today.getFullYear()), String(today.getMonth() + 1).padStart(2, '0')];

        const response = await AuthApi.getLeaveBalanceByUserId(userId, {
          month: Number(selectedMonth),
          year: Number(selectedYear),
        });
        if (response && response.status && response.data) {
          setLeaveBalanceData(response.data);
          setLeaveBalanceSummary(response.summary || null);
        } else {
          setLeaveBalanceData([]);
          setLeaveBalanceSummary(null);
        }
      } catch (error) {
        setLeaveBalanceData([]);
        setLeaveBalanceSummary(null);
      }
      setLeaveBalanceLoading(false);
    };
    if (userId) fetchLeaveBalance();
  }, [userId, leaveBalanceMonthYear]);

  const monthNames = [
    '', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const normalizeLeaveBalanceMonthValue = (monthValue) => {
    if (monthValue === null || monthValue === undefined || monthValue === '') return null;

    const numericMonth = Number(monthValue);
    if (!Number.isNaN(numericMonth) && numericMonth >= 1 && numericMonth <= 12) {
      return numericMonth;
    }

    const matchedIndex = monthNames.findIndex(
      (name) => typeof monthValue === 'string' && name.toLowerCase() === monthValue.toLowerCase()
    );

    return matchedIndex > 0 ? matchedIndex : null;
  };

  const formatLeaveBalanceCount = (value) => {
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return value || 0;
    return Number.isInteger(numericValue) ? numericValue : numericValue.toFixed(1);
  };

  const formatLeaveCycleRange = (startDate, endDate) => {
    if (!startDate || !endDate) return '4 month cycle';

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return '4 month cycle';
    }

    const startMonth = start.toLocaleString('en-US', { month: 'short' });
    const endMonth = end.toLocaleString('en-US', { month: 'short' });
    const startYear = start.getFullYear();
    const endYear = end.getFullYear();

    return startYear === endYear
      ? `${startMonth}-${endMonth} ${startYear}`
      : `${startMonth} ${startYear}-${endMonth} ${endYear}`;
  };

  const formatCarryForwardDetails = (details) => {
    if (!Array.isArray(details) || details.length === 0) return '-';

    return details.map((item) => {
      const monthName = monthNames[item.month] || item.month;
      const parts = [];
      if (Number(item.paid_count) > 0) parts.push(`Paid Leave (${formatLeaveBalanceCount(item.paid_count)})`);
      if (Number(item.sick_count) > 0) parts.push(`Sick Leave (${formatLeaveBalanceCount(item.sick_count)})`);
      return `Carried from ${monthName} ${item.year}: ${parts.join(', ')}`;
    }).join(' | ');
  };

  const getLeaveSummaryMonthLabel = () => {
    const monthNumber = leaveBalanceSummary?.month_number;
    const year = leaveBalanceSummary?.year;
    const monthName = monthNames[monthNumber] || leaveBalanceSummary?.month || '-';
    return `${monthName} ${year || ''}`.trim();
  };

  const openLeaveSummaryDialog = (title, details) => {
    setLeaveSummaryDialog({
      open: true,
      title,
      details: Array.isArray(details) ? details.filter(Boolean) : [],
    });
  };

  const closeLeaveSummaryDialog = () => {
    setLeaveSummaryDialog({
      open: false,
      title: '',
      details: [],
    });
  };

  const openCurrentLeaveDetails = (type) => {
    const monthLabel = getLeaveSummaryMonthLabel();

    if (type === 'paid') {
      openLeaveSummaryDialog('Current Paid Leave Details', [
        `Month: ${monthLabel}`,
        `Current month paid leave allowed: ${formatLeaveBalanceCount(leaveBalanceSummary?.paid_leave_allowed ?? 0)}`,
        `Paid leave used in this month: ${formatLeaveBalanceCount(leaveBalanceSummary?.paid_leave_used_in_month ?? leaveBalanceSummary?.paid_leave_used ?? 0)}`,
        `Total leave used till this month: ${formatLeaveBalanceCount(leaveBalanceSummary?.total_leave_used ?? 0)}`,
        `Paid leave remaining balance: ${formatLeaveBalanceCount(leaveBalanceSummary?.paid_leave_remaining ?? 0)}`,
      ]);
      return;
    }

    if (type === 'sick') {
      openLeaveSummaryDialog('Current Sick Leave Details', [
        `Month: ${monthLabel}`,
        `Current cycle sick leave allowed: ${formatLeaveBalanceCount(leaveBalanceSummary?.sick_leave_allowed ?? 1)}`,
        `Sick leave used in this cycle: ${formatLeaveBalanceCount(leaveBalanceSummary?.sick_leave_used_in_cycle ?? leaveBalanceSummary?.sick_leave_used ?? 0)}`,
        `Sick leave used in this month: ${formatLeaveBalanceCount(leaveBalanceSummary?.sick_leave_used_in_month ?? 0)}`,
        `Sick leave remaining balance: ${formatLeaveBalanceCount(leaveBalanceSummary?.sick_leave_remaining ?? 0)}`,
        `Cycle: ${formatLeaveCycleRange(leaveBalanceSummary?.sick_leave_cycle_start, leaveBalanceSummary?.sick_leave_cycle_end)}`,
      ]);
    }
  };

  const openCarryLeaveDetails = (type) => {
    const detailItems = Array.isArray(leaveBalanceSummary?.carry_forward_detail_items)
      ? leaveBalanceSummary.carry_forward_detail_items
      : [];

    const carryDetails = detailItems
      .filter((item) => (type === 'paid' ? Number(item.paid_count) > 0 : Number(item.sick_count) > 0))
      .map((item) => {
        const monthName = monthNames[item.month] || item.month;
        const count = type === 'paid' ? item.paid_count : item.sick_count;
        const leaveTypeLabel = type === 'paid' ? 'Paid Leave' : 'Sick Leave';
        return `Carried from ${monthName} ${item.year}: ${leaveTypeLabel} (${formatLeaveBalanceCount(count)})`;
      });

    if (carryDetails.length === 0) {
      return;
    }

    openLeaveSummaryDialog(
      type === 'paid' ? 'Carry Forward Paid Leave Details' : 'Carry Forward Sick Leave Details',
      carryDetails
    );
  };

  if (pageLoading) {
    return (
      <div>
        <AuthCheckComponent authToken={authToken} />
        <Header {...props} authUser={authUser} component={<PageLoader />} />
        <Footer {...props} />
      </div>
    );
  }

  const leaveBalanceHeaders = [
    {
      id: 'emp_id',
      numeric: false,
      disablePadding: true,
      label: 'Employee ID',
      sortable: true,
    },
    {
      id: 'firstName',
      numeric: false,
      disablePadding: true,
      label: 'First Name',
      sortable: true,
    },
    {
      id: 'month',
      numeric: false,
      disablePadding: true,
      label: 'Month',
      sortable: true,
    },
    {
      id: 'paid_leave_allowed',
      numeric: false,
      disablePadding: true,
      label: 'Paid Leave Allowed',
      sortable: true,
    },
    {
      id: 'paid_leave_used',
      numeric: false,
      disablePadding: true,
      label: 'Paid Leave Used',
      sortable: true,
    },
    {
      id: 'carry_forward',
      numeric: false,
      disablePadding: true,
      label: 'Carry Forward',
      sortable: true,
    },
    {
      id: 'carry_forward_details',
      numeric: false,
      disablePadding: true,
      label: 'Carry Forward Details',
      sortable: false,
    },
  ];

  const handleLeaveBalanceMonthYearChange = (event) => {
    setLeaveBalanceMonthYear(event.target.value);
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (timeRange) count++; // Treat time range as an active filter even if it's "today"
    if (startDate || endDate) count++; // Only 1 for date range selection
    if (searchQuery) count++;
    return count;
  };
  const activeFilterCount = getActiveFilterCount();


  // Compute available years from leaveBalanceData
  const availableYears = Array.from(new Set(leaveBalanceData.map(item => item.year))).sort();

  // Backend already returns the selected financial year's 12 months (April to March)
  const filteredLeaveBalanceData = searchLeaveBalanceQuery
    ? leaveBalanceData.filter(row => {
        const searchLower = searchLeaveBalanceQuery.toLowerCase();
        return (
          (row.user?.name && row.user.name.toLowerCase().includes(searchLower)) ||
          (row.user?.firstName && row.user.firstName.toLowerCase().includes(searchLower)) ||
          (String(row.month || '').toLowerCase().includes(searchLower)) ||
          (String(row.year || '').toLowerCase().includes(searchLower)) ||
          (String(row.paid_leave_allowed || '').toLowerCase().includes(searchLower)) ||
          (String(row.paid_leave_used || '').toLowerCase().includes(searchLower)) ||
          (String(row.carry_forward || '').toLowerCase().includes(searchLower))
        );
      })
    : leaveBalanceData;

  const leaveBalanceTableData = filteredLeaveBalanceData.map((row) => {
    let carryForwardDetailsDisplay = '-';
    try {
      const parsed = JSON.parse(row.carry_forward_details);
      if (Array.isArray(parsed) && parsed.length > 0) {
        carryForwardDetailsDisplay = formatCarryForwardDetails(parsed);
      }
    } catch { }

    const monthNum = normalizeLeaveBalanceMonthValue(row.month);
    const monthLabel = monthNum ? monthNames[monthNum] : row.month;
    const displayMonth = row.year ? `${monthLabel}-${row.year}` : monthLabel;

    return {
      ...row,
      emp_id: row.user && row.user.name ? row.user.name : '-',
      firstName: row.user && row.user.firstName ? row.user.firstName : '-',
      month: displayMonth,
      paid_leave_allowed: formatLeaveBalanceCount(row.paid_leave_allowed),
      paid_leave_used: formatLeaveBalanceCount(row.total_leave_used_in_month ?? row.paid_leave_used),
      carry_forward: formatLeaveBalanceCount(row.total_carry_forward ?? row.carry_forward ?? 0),
      carry_forward_details: carryForwardDetailsDisplay,
    };
  });

  const leaveCarryForwardText = leaveBalanceSummary?.carry_forward_detail_items?.length
    ? formatCarryForwardDetails(leaveBalanceSummary.carry_forward_detail_items)
    : 'No carry forward';

  const leaveSummaryCards = [
    {
      label: 'Paid Leave',
      value: formatLeaveBalanceCount(leaveBalanceSummary?.paid_leave_remaining ?? 0),
      currentValue: formatLeaveBalanceCount(leaveBalanceSummary?.paid_leave_allowed ?? 0),
      carryValue: formatLeaveBalanceCount(leaveBalanceSummary?.paid_carry_forward ?? 0),
      onCurrentClick: () => openCurrentLeaveDetails('paid'),
      onCarryClick: () => openCarryLeaveDetails('paid'),
    },
    {
      label: 'Sick Leave',
      value: formatLeaveBalanceCount(leaveBalanceSummary?.sick_leave_remaining ?? 0),
      currentValue: formatLeaveBalanceCount(leaveBalanceSummary?.sick_leave_allowed ?? 1),
      carryValue: formatLeaveBalanceCount(leaveBalanceSummary?.sick_leave_carry_forward ?? 0),
      onCurrentClick: () => openCurrentLeaveDetails('sick'),
      onCarryClick: () => openCarryLeaveDetails('sick'),
      subHelper: formatLeaveCycleRange(
        leaveBalanceSummary?.sick_leave_cycle_start,
        leaveBalanceSummary?.sick_leave_cycle_end
      ),
    },
    {
      label: 'Total Leave',
      value: formatLeaveBalanceCount(leaveBalanceSummary?.total_leave_balance ?? 0),
      helper: `Used paid ${formatLeaveBalanceCount(leaveBalanceSummary?.paid_leave_used ?? 0)} | Used sick ${formatLeaveBalanceCount(leaveBalanceSummary?.sick_leave_used ?? 0)}`,
    },
  ];

  const leaveSummaryCardStyle = {
    height: 72,
    width: '100%',
    borderRadius: 12,
    border: darkMode ? '1px solid #2d3748' : '1px solid #dce8f7',
    borderLeft: '4px solid #036dda',
    background: darkMode ? '#1e1e2e' : '#fff',
    boxShadow: darkMode ? '0 2px 12px rgba(0,0,0,0.35)' : '0 2px 12px rgba(3, 109, 218, 0.08)',
  };

  const leaveSummaryCardContentStyle = {
    padding: '8px 14px',
    height: 70,
    minHeight: 70,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'left',
  };

  const leaveSummaryCompactBoxStyle = {
    width: 210,
    height: 72,
    maxWidth: '100%',
    flex: '0 0 auto',
  };


  const profileFields = [
    "firstName", "lastName", "photo", "dob", "doj", "bankName", "bankAccNo",
    "designation", "email", "personal_email", "mobileNo", "last_organization",
    "location", "qualification"
  ];
  const profileCompletionPercentage = (() => {
    const user = userDetails || {};
    const filled = profileFields.filter(field => user[field] && user[field].toString().trim() !== "").length;
    return Math.round((filled / profileFields.length) * 100);
  })();

  const attendanceTableData = totalDurationTime.map((row) => {
    const statusDisplayValue = row.status === 'Comes Late' ? 'Late' : row.status;
    const statusColor = statusColors && statusColors[statusDisplayValue] ? statusColors[statusDisplayValue] : '#000000';
    return {
      ...row,
      date: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.date}
        </div>
      ),
      status: (
        <div
          style={{
            display: 'inline-block',
            backgroundColor: statusColor,
            color: getContrastYIQ(statusColor),
            padding: '4px 8px',
            borderRadius: '4px',
            fontWeight: 'bold',
            fontSize: '12px',
            fontFamily: 'Arial, sans-serif',
            minWidth: '90px',
            width: 'auto',
            textAlign: 'center',
          }}
        >
          {statusDisplayValue}
        </div>
      ),
      firstintime: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.firstintime}
        </div>
      ),
      lastouttime: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.lastouttime}
        </div>
      ),
      totalduration: (
        <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {formatDurationText(row.totalduration)}
        </div>
      ),
      breakduration: (
        <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {formatDurationText(row.breakduration)}
        </div>
      ),
      breaks: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.breaks}
        </div>
      ),
    };
  });

  const attendanceHeaderControls = (
    <div className="holiday-toolbar-controls" style={{ position: 'relative' }}>
      <Tooltip title="Filter">
        <Button
          variant="contained"
          color="primary"
          onClick={openFilterModal}
          className={`${classes.actionButton} common-action-button`}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <FilterListIcon style={{ marginRight: activeFilterCount > 0 ? 6 : 0 }} />
          {activeFilterCount > 0 && `(${activeFilterCount})`}
        </Button>
      </Tooltip>
      <div className="holiday-search-wrapper" style={{ position: 'relative' }}>
        <TextField
          className="holiday-search-field"
          placeholder="Search"
          value={searchQuery}
          onChange={handleSearchChange}
          variant="outlined"
          InputLabelProps={{ shrink: false }}
          InputProps={{
            style: {
              height: "40px",
              borderRadius: "8px"
            },
            endAdornment: (
              <InputAdornment position="end">
                {searchQuery && (
                  <ClearIcon 
                    onClick={handleClearSearch} 
                    className="holiday-search-clear-icon" 
                  />
                )}
                <SearchIcon 
                  onClick={handleSearch} 
                  className="holiday-search-icon" 
                />
              </InputAdornment>
            ),
          }}
        />

        {showSuggestions && suggestions.length > 0 && (
          <Paper style={{ position: 'absolute', zIndex: 1, marginTop: '5px', width: "300px" }}>
            <List>
              {suggestions.map((suggestion, index) => (
                <ListItem
                  key={index}
                  button
                  style={{ fontSize: "medium" }}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion}
                </ListItem>
              ))}
            </List>
          </Paper>
        )}
      </div>
    </div>
  );

  const leaveTableData = leaveData.map((row) => {
    const statusDisplayValue = row.status === 'Comes Late' ? 'Late' : row.status;
    const statusColor =
      statusDisplayValue === "Approved" ? "#16a34a" :
        statusDisplayValue === "Declined" ? "#e4aaaaff" :
          statusDisplayValue === "Cancelled" ? "#eab308" :
            statusDisplayValue === "Unapproved" ? "#e34d4d" :
              "#e5e562ff";

    const dateRangeVal = row.date_range || '';
    const dateRangeParts = dateRangeVal.split(/\s+to\s+/i);
    let dateRangeNode;
    if (dateRangeParts.length === 2) {
      dateRangeNode = (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.2', padding: '10px 0' }}>
          <span style={{ whiteSpace: 'nowrap' }}>{dateRangeParts[0]}</span>
          <span style={{ fontSize: '0.85em', opacity: 0.8, margin: '2px 0' }}>To</span>
          <span style={{ whiteSpace: 'nowrap' }}>{dateRangeParts[1]}</span>
        </div>
      );
    } else {
      dateRangeNode = <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{dateRangeVal}</div>;
    }

    const createdAtVal = row.created_at || '';
    const createdAtParts = createdAtVal.split(' ');
    const createdAtNode = (
      <div style={{ lineHeight: '1.2', display: 'flex', flexDirection: 'column' }}>
        <span>{createdAtParts[0]}</span>
        <span style={{ fontSize: '0.85em', color: 'gray' }}>{createdAtParts.slice(1).join(' ')}</span>
      </div>
    );

    const updatedAtVal = row.updated_at || '';
    const updatedAtParts = updatedAtVal.split(' ');
    const updatedAtNode = (
      <div style={{ lineHeight: '1.2', display: 'flex', flexDirection: 'column' }}>
        <span>{updatedAtParts[0]}</span>
        <span style={{ fontSize: '0.85em', color: 'gray' }}>{updatedAtParts.slice(1).join(' ')}</span>
      </div>
    );

    return {
      ...row,
      emp_id: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.emp_id}
        </div>
      ),
      firstName: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>
          {row.firstName}
        </div>
      ),
      leaveType: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.leaveType}
        </div>
      ),
      ticket_mesasge: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.ticket_mesasge}
        </div>
      ),
      date_range: dateRangeNode,
      no_of_days: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.no_of_days}
        </div>
      ),
      status: (
        <div
          style={{
            display: 'inline-block',
            backgroundColor: statusColor,
            color: getContrastYIQ(statusColor),
            padding: '4px 8px',
            borderRadius: '4px',
            fontWeight: 'bold',
            fontSize: '12px',
            fontFamily: 'Arial, sans-serif',
            minWidth: '90px',
            width: 'auto',
            textAlign: 'center',
          }}
        >
          {statusDisplayValue}
        </div>
      ),
      cancel_reason: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.cancel_reason}
        </div>
      ),
      c_reason: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.c_reason}
        </div>
      ),
      created_at: createdAtNode,
      updated_at: updatedAtNode,
    };
  });

  const leaveHeaderControls = (
    <div className="holiday-toolbar-controls" style={{ position: 'relative' }}>
      <FormControl variant="outlined" className="holiday-year-filter">
        <TextField
          id="datetime-local-header"
          className="leave-tab-month-filter"
          label="Select Month/Year"
          variant="outlined"
          type="month"
          defaultValue={leaveMonthYear.toISOString().slice(0, 7)}
          onChange={handleMonthChange}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: "2000-01", max: new Date().toISOString().slice(0, 7) }}
          style={{ height: '40px' }}
          InputProps={{
            style: {
              height: '40px'
            }
          }}
        />
      </FormControl>
      <div className="holiday-search-wrapper" style={{ position: 'relative' }}>
        <TextField
          className="holiday-search-field hardik"
          label="Search"
          value={searchLeaveQuery}
          onChange={handleLeaveSearchChange}
          variant="outlined"
          InputLabelProps={{
            shrink: searchLeaveQuery !== "",
            style: {
              color: '#036dda',
              transform: searchLeaveQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
              transition: 'transform 0.2s ease-in-out',
            },
          }}
          InputProps={{
            style: {
              backgroundColor: 'lightgray',
              borderRadius: '25px',
              height: "40px",
              overflow: 'hidden'
            },
            endAdornment: (
              <InputAdornment position="end">
                {searchLeaveQuery && (
                  <ClearIcon onClick={handleLeaveClearSearch} style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit', marginRight: '5px', fontSize: '18px' }} />
                )}
                <SearchIcon style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit' }} onClick={handleLeaveSearch} />
              </InputAdornment>
            ),
          }}
        />

        {LeaveshowSuggestions && Leavesuggestions.length > 0 && (
          <Paper className="search-leave" style={{ position: 'absolute', zIndex: 1, marginTop: '5px', width: "300px" }}>
            <List>
              {Leavesuggestions.map((suggestion, index) => (
                <ListItem
                  key={index}
                  button
                  style={{ fontSize: "medium" }}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion}
                </ListItem>
              ))}
            </List>
          </Paper>
        )}
      </div>
    </div>
  );

  const salaryTableData = salary.map((row) => {
    return {
      ...row,
      name: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.name}
        </div>
      ),
      firstName: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>
          {row.firstName}
        </div>
      ),
      BasicSalary: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.BasicSalary}
        </div>
      ),
      DA: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.DA}
        </div>
      ),
      HRA: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.HRA}
        </div>
      ),
      CA: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.CA}
        </div>
      ),
      Tax: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.Tax}
        </div>
      ),
      netSalary: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.netSalary}
        </div>
      ),
      MonthYear: (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
          {row.MonthYear}
        </div>
      ),
      actions: (
        <div style={{ display: 'flex', gap: '4px' }}>
          <Tooltip title="Show">
            <IconButton
              variant="contained"
              color="primary"
              style={{ padding: "4px" }}
              onClick={() => openModal(row.id)}
            >
              <FontAwesomeIconComponent
                classes="fa fa-eye"
                colorName="primary"
                fontSize={"small"}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download">
            <IconButton
              variant="contained"
              color="primary"
              style={{ padding: "4px" }}
              onClick={() => downloadSlip(row.id)}
            >
              <FontAwesomeIconComponent
                classes="fa fa-download"
                colorName="primary"
                fontSize={"small"}
              />
            </IconButton>
          </Tooltip>
        </div>
      )
    };
  });

  const leaveBalanceHeaderControls = (
    <div className="holiday-toolbar-controls" style={{ position: 'relative' }}>
      <div className="holiday-search-wrapper" style={{ position: 'relative' }}>
        <TextField
          className="holiday-search-field"
          placeholder="Search"
          value={searchLeaveBalanceQuery}
          onChange={handleLeaveBalanceSearchChange}
          variant="outlined"
          InputLabelProps={{ shrink: false }}
          InputProps={{
            style: {
              height: "40px",
              borderRadius: "8px"
            },
            endAdornment: (
              <InputAdornment position="end">
                {searchLeaveBalanceQuery && (
                  <ClearIcon
                    onClick={handleLeaveBalanceClearSearch}
                    className="holiday-search-clear-icon"
                  />
                )}
                <SearchIcon
                  onClick={handleLeaveBalanceSearch}
                  className="holiday-search-icon"
                />
              </InputAdornment>
            ),
          }}
        />
        {LeaveBalanceshowSuggestions && LeaveBalancesuggestions.length > 0 && (
          <Paper style={{ position: 'absolute', zIndex: 1, marginTop: '5px', width: "300px" }}>
            <List>
              {LeaveBalancesuggestions.map((suggestion, index) => (
                <ListItem
                  key={index}
                  button
                  style={{ fontSize: "medium" }}
                  onClick={() => {
                    setSearchLeaveBalanceQuery(suggestion);
                    setLeaveBalanceShowSuggestions(false);
                    setLeaveBalanceSuggestions([]);
                    setLeaveBalancePage(0);
                  }}
                >
                  {suggestion}
                </ListItem>
              ))}
            </List>
          </Paper>
        )}
      </div>
    </div>
  );

  const salaryHeaderControls = (
    <div className="holiday-toolbar-controls" style={{ position: 'relative' }}>
      <FormControl variant="outlined" className="holiday-year-filter">
        <TextField
          id="salary-slip-month-filter"
          className="salary-slip-month-filter"
          label="Select Month/Year"
          variant="outlined"
          type="month"
          value={selectedMonthYear}
          onChange={handleMonthYearChange}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{ min: "2000-01", max: new Date().toISOString().slice(0, 7) }}
          style={{ height: '40px' }}
          InputProps={{
            style: {
              height: '40px'
            }
          }}
        />
      </FormControl>
      <div className="holiday-search-wrapper" style={{ position: 'relative' }}>
        <TextField
          className="holiday-search-field hardik"
          label="Search"
          value={searchSalaryQuery}
          onChange={handleSalarySearchChange}
          variant="outlined"
          InputLabelProps={{
            shrink: searchSalaryQuery !== "",
            style: {
              color: '#036dda',
              transform: searchSalaryQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
              transition: 'transform 0.2s ease-in-out',
            },
          }}
          InputProps={{
            style: {
              backgroundColor: 'lightgray',
              borderRadius: '25px',
              height: "40px",
              overflow: 'hidden'
            },
            endAdornment: (
              <InputAdornment position="end">
                {searchSalaryQuery && (
                  <ClearIcon onClick={handleSalaryClearSearch} style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit', marginRight: '5px', fontSize: '18px' }} />
                )}
                <SearchIcon onClick={handleSalarySearch} style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit' }} />
              </InputAdornment>
            ),
          }}
        />

        {SalaryshowSuggestions && Salarysuggestions.length > 0 && (
          <Paper style={{ position: 'absolute', zIndex: 1, marginTop: '5px', width: "300px" }}>
            <List>
              {Salarysuggestions.map((suggestion, index) => (
                <ListItem
                  key={index}
                  button
                  style={{ fontSize: "medium" }}
                  onClick={() => handleSalarySuggestionClick(suggestion)}
                >
                  {suggestion}
                </ListItem>
              ))}
            </List>
          </Paper>
        )}
      </div>
    </div>
  );

  return (
    <div>
      <AuthCheckComponent authToken={authToken} />
      <Header
        {...props}
        authUser={authUser}
        component={
          <div>
            <div className="holiday-breadcrumb-card" style={{ marginBottom: '20px' }}>
              <Breadcrumb
                {...props}
                primaryPageName="Users"
                primaryPageLink="/users"
                isSecondaryPage={true}
                secondaryPageName="User Profile" />
            </div>

            <div style={{ width: "100%" }}>
              <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                aria-label="settings tabs"
                indicatorColor="primary"
                textColor="primary"
                style={{ marginBottom: '20px', borderBottom: '1px solid #e0e0e0' }}
              >
                <Tab label="User Profile" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                <Tab label="User Attendance" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                <Tab label="Leave" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                <Tab label="Salary Slip" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                <Tab label="Leave Balance" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
              </Tabs>

              <TabPanel value={tabIndex} index={0}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <Card className={classes.profileCard}>
                      <CardContent>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
                          <Box style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
                            <ProfileCompletionCircle
                              percentage={profileCompletionPercentage}
                              user={userDetails}
                              fields={profileFields}
                              size={130}
                              getFieldDisplayName={getFieldDisplayName}
                            />
                            <img
                              src={(userimg1 && userimg1.data && typeof userimg1.data === 'string' && userimg1.data.trim() !== "" && userimg1.data !== "null" && userimg1.data !== "undefined") ? userimg1.data : defaultAvatar}
                              alt="User"
                              onError={(e) => { e.target.onerror = null; e.target.src = defaultAvatar; }}
                              style={{
                                width: "110px",
                                height: "110px",
                                borderRadius: "50%",
                                position: 'absolute',
                                zIndex: 1,
                                objectFit: 'cover',
                                border: '4px solid white',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                              }}
                            />
                          </Box>
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: 'bold',
                              color: profileCompletionPercentage >= 90 ? '#52C41A' :
                                profileCompletionPercentage >= 70 ? '#FFA500' :
                                  profileCompletionPercentage >= 40 ? '#aaa20b' : '#FF4D4F'
                            }}
                          >
                            Profile Completion: {profileCompletionPercentage}%
                          </Typography>
                        </div>

                        <div className={classes.infoItem} style={{ textAlign: 'center' }}>
                          <Typography className={classes.infoLabel}>Department</Typography>
                          <Typography className={classes.infoValue}>{getValidatedDepartment(userDetails.department)}</Typography>
                        </div>

                        <div className={classes.infoItem} style={{ textAlign: 'center' }}>
                          <Typography className={classes.infoLabel}>Role</Typography>
                          <Typography className={classes.infoValue}>
                            {userDetails.roles && userDetails.roles.length > 0 ? userDetails.roles[0].name : '-'}
                          </Typography>
                        </div>

                        <div className={classes.infoItem} style={{ textAlign: 'center', marginBottom: 0 }}>
                          <Typography className={classes.infoLabel}>Registered Email</Typography>
                          <Typography className={classes.infoValue}>{userDetails.email}</Typography>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>

                  <Grid item xs={12} sm={8} style={{ marginBottom: "50px" }}>
                    <Card className={classes.detailsCard}>
                      <CardContent className={classes.cardContent}>

                        {/* Personal Info Section */}
                        <Box mb={4}>
                          <div className={classes.sectionHeader}>
                            <Typography variant="h6" className={classes.sectionTitle}>
                              <PersonIcon className={classes.sectionIcon} />
                              Personal Info
                            </Typography>
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<EditIcon />}
                              className={classes.editButton}
                              onClick={() => handleEditOpen('personal')}
                            >
                              Edit
                            </Button>
                          </div>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <PersonIcon className={classes.labelIcon} /> Name
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.firstName} {userDetails.lastName}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <PhoneIcon className={classes.labelIcon} /> Phone Number
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.mobileNo || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <EmailIcon className={classes.labelIcon} /> Personal Email
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.personal_email || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <EmailIcon className={classes.labelIcon} /> Official Email ID
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.email}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <CakeIcon className={classes.labelIcon} /> Date of Birth
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.dob || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <WcIcon className={classes.labelIcon} /> Gender
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.gender || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <SchoolIcon className={classes.labelIcon} /> Qualification
                                </Typography>
                                <Typography className={classes.infoValue}>
                                  {userDetails.qualification && userDetails.qualification !== 'None'
                                    ? userDetails.qualification
                                    : 'None'}
                                </Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <BusinessIcon className={classes.labelIcon} /> Last Organization
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.last_organization || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <LocationOnIcon className={classes.labelIcon} /> Address
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.location || '-'}</Typography>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* Bank Info Section */}
                        <Box mb={4}>
                          <div className={classes.sectionHeader}>
                            <Typography variant="h6" className={classes.sectionTitle}>
                              <AccountBalanceIcon className={classes.sectionIcon} />
                              Bank Info
                            </Typography>
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<EditIcon />}
                              className={classes.editButton}
                              onClick={() => handleEditOpen('bank')}
                            >
                              Edit
                            </Button>
                          </div>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <AccountBalanceIcon className={classes.labelIcon} /> Bank Name
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.bankName || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <ConfirmationNumberIcon className={classes.labelIcon} /> Bank Acc No
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.bankAccNo || '-'}</Typography>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* Office Info Section */}
                        <Box>
                          <div className={classes.sectionHeader}>
                            <Typography variant="h6" className={classes.sectionTitle}>
                              <BusinessIcon className={classes.sectionIcon} />
                              Office Info
                            </Typography>
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<EditIcon />}
                              className={classes.editButton}
                              onClick={() => handleEditOpen('office')}
                            >

                              Edit
                            </Button>
                          </div>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <DateRangeIcon className={classes.labelIcon} /> Date Of Joining
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.doj ? formatDate(userDetails.doj) : '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <WorkIcon className={classes.labelIcon} /> Designation
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.designation || '-'}</Typography>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>

                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

                {/* Edit Dialogs */}
                <Dialog
                  open={openEditPersonal}
                  onClose={() => handleEditClose('personal')}
                  maxWidth="md"
                  fullWidth
                  PaperProps={{
                    style: { borderRadius: 16 }
                  }}
                >
                  <DialogTitle disableTypography className={classes.dialogTitle}>
                    <Typography variant="h6">Edit Personal Info</Typography>
                  </DialogTitle>
                  <DialogContent className={`${classes.dialogContent} profile-edit-form`}>
                    <DialogContentText>
                      Update your personal information here.
                    </DialogContentText>

                    <Grid container spacing={2}>
                      {/* Profile Picture Drag & Drop */}
                      <Grid item xs={12}>
                        <div
                          className={`${classes.uploadArea} ${dragActive ? classes.uploadAreaActive : ''}`}
                          onDragEnter={handleDrag}
                          onDragLeave={handleDrag}
                          onDragOver={handleDrag}
                          onDrop={handleDrop}
                          onClick={() => document.getElementById('raised-button-file').click()}
                        >
                          <input
                            accept="image/*"
                            className={classes.fileInput}
                            id="raised-button-file"
                            type="file"
                            onChange={imgUpload}
                          />
                          <img
                            src={editPersonalInfo.photo || defaultAvatar}
                            alt="User profile image"
                            style={{
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              marginBottom: '8px',
                              objectFit: 'cover',
                              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                            }}
                          />
                          <Typography variant="subtitle2" style={{ color: 'var(--hrms-primary-blue-end, #036dda)', fontWeight: 'bold', marginBottom: '2px' }}>
                            Drag & Drop your file here
                          </Typography>
                          <Typography variant="caption" style={{ color: 'var(--hrms-primary-blue-end, #036dda)', marginBottom: '4px' }}>
                            or
                          </Typography>
                          <Button
                            variant="outlined"
                            color="primary"
                            component="span"
                            size="small"
                            startIcon={<CloudUploadIcon />}
                            style={{
                              textTransform: 'none',
                              fontWeight: 'bold',
                              padding: '2px 10px',
                              fontSize: '0.8rem',
                              color: 'var(--hrms-primary-blue-end, #036dda)',
                              borderColor: 'var(--hrms-primary-blue-border, #1864bc)'
                            }}
                          >
                            Upload a file
                          </Button>
                        </div>
                      </Grid>
                      {/* First Name / Last Name */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          autoFocus
                          margin="dense"
                          label="First Name"
                          placeholder="Enter First Name"
                          name="firstName"
                          value={editPersonalInfo.firstName}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Last Name"
                          placeholder="Enter Last Name"
                          name="lastName"
                          value={editPersonalInfo.lastName}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      {/* Emails */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Email Address"
                          placeholder="Enter Email Address"
                          name="email"
                          value={editPersonalInfo.email}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Personal Email"
                          placeholder="Enter Personal Email"
                          name="personal_email"
                          value={editPersonalInfo.personal_email}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>



                      {/* Birthday and Gender in same row */}
                      {/* Birthday and Gender */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          autoFocus
                          margin="dense"
                          label="Birthday"
                          type="date"
                          name="dob"
                          value={formatDate(editPersonalInfo.dob)}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CakeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FormControl component="fieldset" fullWidth className={classes.customTextField}>
                          <FormLabel component="legend">Gender</FormLabel>
                          <RadioGroup
                            row
                            aria-label="gender"
                            name="gender"
                            onChange={handlePersonalInfoChange}
                            value={editPersonalInfo.gender}
                          >
                            <FormControlLabel value="Female" control={<Radio />} label="Female" />
                            <FormControlLabel value="Male" control={<Radio />} label="Male" />
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      {/* Qualification and Last Organization */}
                      <Grid item xs={12} sm={6}>
                        <FormControl variant="outlined" fullWidth className={`${classes.customTextField} ${classes.qualificationSelect}`}>
                          <InputLabel id="demo-simple-select-outlined-label">Qualification</InputLabel>
                          <Select
                            id="outlined-basic"
                            name="qualification"
                            label="Qualification"
                            variant="outlined"
                            value={qualifications.find(q => q.qualification.toLowerCase() === (editPersonalInfo.qualification || '').toLowerCase())?.qualification || 'None'}
                            onChange={handlePersonalInfoChange}
                            startAdornment={
                              <InputAdornment position="start">
                                <SchoolIcon />
                              </InputAdornment>
                            }
                          >
                            <MenuItem value="None">
                              <em>None</em>
                            </MenuItem>
                            {qualifications.map((qualification) => (
                              <MenuItem key={qualification.id} value={qualification.qualification}>
                                {qualification.qualification}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Last Organization"
                          name="last_organization"
                          value={editPersonalInfo.last_organization}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <BusinessIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      {/* Phone Number and Location */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Phone Number"
                          name="mobileNo"
                          value={editPersonalInfo.mobileNo}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          error={editPersonalInfo.mobileNo.length > 0 && editPersonalInfo.mobileNo.length < 10}
                          helperText={editPersonalInfo.mobileNo.length > 0 && editPersonalInfo.mobileNo.length < 10 ? "Phone number must be 10 digits" : ""}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Location"
                          name="location"
                          value={editPersonalInfo.location}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LocationOnIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions className={classes.dialogActions}>
                    <Button
                      onClick={() => handleUpdateUser('personal')}
                      color="primary"
                      variant="contained"
                      className={classes.actionButton}
                      style={{
                        background: 'linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)',
                        color: '#ffffff'
                      }}
                    >
                      Save Changes
                    </Button>
                    <Button onClick={() => handleEditClose('personal')} color="default" variant="outlined" className={`${classes.actionButton} btn-cancel`}>
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>


                <Dialog
                  open={openEditBank}
                  onClose={() => handleEditClose('bank')}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                    style: { borderRadius: 16 }
                  }}
                >
                  <DialogTitle disableTypography className={classes.dialogTitle}>
                    <Typography variant="h6">Edit Bank Info</Typography>
                  </DialogTitle>
                  <DialogContent className={`${classes.dialogContent} profile-edit-form`}>
                    <DialogContentText>
                      Update your bank information here.
                    </DialogContentText>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          autoFocus
                          margin="dense"
                          label="Bank Name"
                          name="bankName"
                          placeholder="Enter Bank Name"
                          value={editBankInfo.bankName}
                          onChange={handleBankInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <AccountBalanceIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Bank Account Number"
                          name="bankAccNo"
                          placeholder="Enter Bank AccNo"
                          value={editBankInfo.bankAccNo}
                          onChange={handleBankInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <ConfirmationNumberIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions className={classes.dialogActions}>
                    <Button
                      onClick={() => handleUpdateUser('bank')}
                      color="primary"
                      variant="contained"
                      className={classes.actionButton}
                      style={{
                        background: 'linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)',
                        color: '#ffffff'
                      }}
                    >
                      Save Changes
                    </Button>
                    <Button onClick={() => handleEditClose('bank')} color="default" variant="outlined" className={`${classes.actionButton} btn-cancel`}>
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  open={openEditOffice}
                  onClose={() => handleEditClose('office')}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                    style: { borderRadius: 16 }
                  }}
                >
                  <DialogTitle disableTypography className={classes.dialogTitle}>
                    <Typography variant="h6">Edit Office Info</Typography>
                  </DialogTitle>
                  <DialogContent className={`${classes.dialogContent} profile-edit-form`}>
                    <DialogContentText>
                      Update your office information here.
                    </DialogContentText>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          autoFocus
                          margin="dense"
                          label="Date Of Joining"
                          name="doj"
                          type="date"
                          value={editOfficeInfo.doj}
                          onChange={handleOfficeInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <DateRangeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Designation"
                          name="designation"
                          placeholder="Enter designation "
                          value={editOfficeInfo.designation}
                          onChange={handleOfficeInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <WorkIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions className={classes.dialogActions}>
                    <Button
                      onClick={() => handleUpdateUser('office')}
                      color="primary"
                      variant="contained"
                      className={classes.actionButton}
                      style={{
                        background: 'linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)',
                        color: '#ffffff'
                      }}
                    >
                      Save Changes
                    </Button>
                    <Button onClick={() => handleEditClose('office')} color="default" variant="outlined" className={`${classes.actionButton} btn-cancel`}>
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>
              </TabPanel>

              <TabPanel value={tabIndex} index={1} style={{ marginBottom: "2%" }}>
                {/* Filter Modal */}
                <Dialog
                  open={showFilterModal}
                  onClose={() => setShowFilterModal(false)}
                  disableScrollLock={true}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                    style: {
                      borderRadius: "16px",
                      padding: "0",
                      background: darkMode ? '#1e1e2e' : '#ffffff',
                      boxShadow: darkMode ? '0 8px 32px rgba(0,0,0,0.4)' : '0 8px 32px rgba(3, 109, 218, 0.15)',
                    }
                  }}
                >
                  <DialogTitle style={{
                    background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                    color: "white",
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: "bold",
                    position: "relative",
                    minHeight: "36px",
                    padding: "8px 0 8px 0",
                    lineHeight: 1.2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    Filter Attendance
                    <CloseIcon
                      style={{
                        position: "absolute",
                        top: 8,
                        right: 10,
                        cursor: "pointer",
                        color: "#fff",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "50%",
                        padding: "2px",
                        width: 28,
                        height: 28,
                        transition: "background-color 0.2s"
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.3)"}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.2)"}
                      onClick={() => setShowFilterModal(false)}
                    />
                  </DialogTitle>
                  <DialogContent style={{ padding: "24px", background: darkMode ? '#1e1e2e' : '#ffffff' }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <FormControl variant="outlined" fullWidth className={classes.customTextField}>
                          <InputLabel id="modal-time-range-label">Time Range</InputLabel>
                          <Select
                            labelId="modal-time-range-label"
                            id="modal-time-range"
                            value={modalTimeRange}
                            onChange={(e) => setModalTimeRange(e.target.value)}
                            label="Time Range"
                            style={{ backgroundColor: 'transparent' }}
                            SelectDisplayProps={{
                              style: { textAlign: 'left' }
                            }}
                            MenuProps={{
                              PaperProps: {
                                className: "attendance-filter-menu",
                              },
                            }}
                          >
                            <MenuItem value="today">Today</MenuItem>
                            <MenuItem value="last7days">Last 7 Days</MenuItem>
                            <MenuItem value="last30days">Last 30 Days</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Start Date"
                          type="date"
                          value={modalStartDate}
                          onChange={(e) => setModalStartDate(e.target.value)}
                          fullWidth
                          className={classes.customTextField}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            style: { backgroundColor: 'transparent' }
                          }}
                          inputProps={{
                            style: { textAlign: 'left' }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="End Date"
                          type="date"
                          value={modalEndDate}
                          onChange={(e) => setModalEndDate(e.target.value)}
                          fullWidth
                          className={classes.customTextField}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            style: { backgroundColor: 'transparent' }
                          }}
                          inputProps={{
                            style: { textAlign: 'left' }
                          }}
                        />
                      </Grid>
                    </Grid>

                    <div style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      gap: 12,
                      marginTop: "24px"
                    }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={applyFilters}
                        style={{
                          minWidth: "100px",
                          background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                          textTransform: "none",
                          fontWeight: "600",
                          borderRadius: 8
                        }}
                      >
                        Apply
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={clearFilters}
                        style={{
                          minWidth: "100px",
                          borderColor: "var(--hrms-primary-blue-border, #036dda)",
                          color: "var(--hrms-primary-blue-end, #036dda)",
                          textTransform: "none",
                          fontWeight: "600",
                          borderRadius: 8
                        }}
                      >
                        Clear
                      </Button>
                    </div>
                  </DialogContent>
                </Dialog>

                <Box width="100%" style={{ marginTop: '10px' }}>
                  <TableComponent
                    {...props}
                    tableTh={attendanceHeaders}
                    tableData={attendanceTableData}
                    tableCount={totalDurationTime.length}
                    isLoading={false}
                    colNameToShow={[
                      'date',
                      'status',
                      'firstintime',
                      'lastouttime',
                      'totalduration',
                      'breakduration',
                      'breaks'
                    ]}
                    openPopUp={false}
                    actionBtns={null}
                    modelName={"User Attendance"}
                    orderBy="date"
                    order="desc"
                    page={attendancePage}
                    rowsPerPage={pageSize}
                    onPageChange={(newPage) => setAttendancePage(newPage)}
                    onRowsPerPageChange={(event) => {
                      setPageSize(parseInt(event.target.value, 10));
                      setAttendancePage(0);
                    }}
                    extraHeaderContent={attendanceHeaderControls}
                    bottomBarContent={
                      <Box style={{ marginLeft: '8px', fontSize: '14px', fontWeight: 500, color: darkMode ? '#ffffff' : 'inherit' }}>
                        Total Working Hours: {totalWorkingHours}
                      </Box>
                    }
                    shellClassName="holiday-table-shell"
                  />
                </Box>
              </TabPanel>

              <TabPanel value={tabIndex} index={2} style={{ marginBottom: "2%" }}>
                <Box width="100%" style={{ marginTop: '10px' }}>
                  <TableComponent
                    {...props}
                    tableTh={leaveHeaders}
                    tableData={leaveTableData}
                    tableCount={leaveData.length}
                    isLoading={false}
                    colNameToShow={[
                      'emp_id',
                      'firstName',
                      'leaveType',
                      'ticket_mesasge',
                      'date_range',
                      'no_of_days',
                      'status',
                      'cancel_reason',
                      'c_reason',
                      'created_at',
                      'updated_at'
                    ]}
                    openPopUp={false}
                    actionBtns={null}
                    modelName={"Leave Records"}
                    orderBy="created_at"
                    order="desc"
                    page={leavePage}
                    rowsPerPage={pageSize}
                    onPageChange={(newPage) => setLeavePage(newPage)}
                    onRowsPerPageChange={(event) => {
                      setPageSize(parseInt(event.target.value, 10));
                      setLeavePage(0);
                    }}
                    extraHeaderContent={leaveHeaderControls}
                    shellClassName="holiday-table-shell"
                  />
                </Box>
              </TabPanel>

              <TabPanel value={tabIndex} index={3} style={{ marginBottom: "2%" }}>
                <Box width="100%" style={{ marginTop: '10px' }}>
                  <TableComponent
                    {...props}
                    tableTh={salaryHeaders}
                    tableData={salaryTableData}
                    tableCount={salary.length}
                    isLoading={false}
                    colNameToShow={[
                      'name',
                      'firstName',
                      'BasicSalary',
                      'DA',
                      'HRA',
                      'CA',
                      'Tax',
                      'netSalary',
                      'MonthYear',
                      'actions'
                    ]}
                    openPopUp={false}
                    actionBtns={null}
                    modelName={"Salary Slips"}
                    orderBy="MonthYear"
                    order="desc"
                    page={salaryPage}
                    rowsPerPage={pageSize}
                    onPageChange={(newPage) => setSalaryPage(newPage)}
                    onRowsPerPageChange={(event) => {
                      setPageSize(parseInt(event.target.value, 10));
                      setSalaryPage(0);
                    }}
                    extraHeaderContent={salaryHeaderControls}
                    shellClassName="holiday-table-shell"
                  />
                </Box>
              </TabPanel>

              <TabPanel value={tabIndex} index={4} style={{ marginBottom: "2%" }}>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  alignItems="stretch"
                  style={{ gap: 10, marginBottom: '20px', justifyContent: 'flex-start', paddingLeft: 0 }}
                >
                  <Box style={leaveSummaryCompactBoxStyle}>
                    <Card 
                      className="leave-summary-card"
                      style={{
                      height: 72,
                      width: '100%',
                      borderRadius: 12,
                      border: darkMode ? '1px solid #2d3748' : '1px solid #dce8f7',
                      borderLeft: '4px solid #036dda',
                      background: darkMode ? '#1e1e2e' : '#fff',
                      boxShadow: darkMode ? '0 2px 12px rgba(0,0,0,0.35)' : '0 2px 12px rgba(3, 109, 218, 0.08)',
                      display: 'flex',
                      alignItems: 'center',
                      padding: '0 14px',
                    }}>
                      <TextField
                        id="leave-balance-month-year"
                        className="holiday-form-input leave-balance-month-filter"
                        label="Select Month/Year"
                        type="month"
                        value={leaveBalanceMonthYear}
                        onChange={handleLeaveBalanceMonthYearChange}
                        InputLabelProps={{
                          shrink: true,
                          style: {
                            color: darkMode ? '#ffffff' : '#000000',
                            fontSize: '0.85rem',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                          }
                        }}
                        inputProps={{
                          min: "2000-01",
                          max: new Date().toISOString().slice(0, 7),
                          style: {
                            color: darkMode ? '#e6f2ff' : 'var(--hrms-primary-blue-text, #1f3f5b)',
                            fontWeight: 700,
                            fontSize: '0.95rem',
                            marginTop: '4px',
                          }
                        }}
                        InputProps={{
                          disableUnderline: true,
                          style: { width: '100%' }
                        }}
                        fullWidth
                      />
                    </Card>
                  </Box>
                  {leaveSummaryCards.map((card) => (
                    <Box key={card.label} style={leaveSummaryCompactBoxStyle}>
                      <Card className="leave-summary-card" style={leaveSummaryCardStyle}>
                        <CardContent style={leaveSummaryCardContentStyle}>
                          <Typography
                            variant="body1"
                            style={{
                              color: darkMode ? '#e6f2ff' : 'var(--hrms-primary-blue-text, #1f3f5b)',
                              marginBottom: 4,
                              fontWeight: 700,
                              fontSize: '0.95rem',
                              lineHeight: 1.1,
                            }}
                          >
                            {card.label} : <span style={{ color: 'var(--hrms-primary-blue-end, #036dda)', fontWeight: 800 }}>{card.value}</span>
                          </Typography>
                          <Typography
                            variant="caption"
                            style={{
                              color: darkMode ? '#cfe4ff' : 'var(--hrms-primary-blue-muted, #56748f)',
                              display: 'block',
                              lineHeight: 1.15,
                              fontSize: '0.72rem',
                            }}
                          >
                            {card.currentValue !== undefined && card.carryValue !== undefined ? (
                              <>
                                <span
                                  onClick={card.onCurrentClick}
                                  style={{
                                    color: 'var(--hrms-primary-blue-end, #036dda)',
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                  }}
                                >
                                  Current {card.currentValue}
                                </span>
                                {' + '}
                                <span
                                  onClick={() => {
                                    if (Number(card.carryValue) > 0 && card.onCarryClick) {
                                      card.onCarryClick();
                                    }
                                  }}
                                  style={{
                                    color: Number(card.carryValue) > 0
                                      ? 'var(--hrms-primary-blue-end, #036dda)'
                                      : (darkMode ? '#cfe4ff' : 'var(--hrms-primary-blue-muted, #56748f)'),
                                    fontWeight: Number(card.carryValue) > 0 ? 700 : 500,
                                    cursor: Number(card.carryValue) > 0 ? 'pointer' : 'default',
                                  }}
                                >
                                  Carry {card.carryValue}
                                </span>
                              </>
                            ) : (
                              card.helper
                            )}
                          </Typography>
                          {card.subHelper ? (
                            <Typography
                              variant="caption"
                              style={{
                                color: darkMode ? '#a8c8ea' : 'var(--hrms-primary-blue-muted, #56748f)',
                                display: 'block',
                                lineHeight: 1.05,
                                marginTop: 2,
                                fontSize: '0.58rem',
                              }}
                            >
                              {card.subHelper}
                            </Typography>
                          ) : null}
                        </CardContent>
                      </Card>
                    </Box>
                  ))}
                </Box>
                <Typography
                  variant="caption"
                  style={{
                    display: 'block',
                    marginBottom: '14px',
                    color: darkMode ? '#ffffff' : '#000000',
                    fontSize: '0.92rem',
                    fontWeight: 700,
                    lineHeight: 1.4,
                  }}
                >
                  Note: Leave balance resets every financial year (April to March). Unused leaves are not carried to the next financial year.
                </Typography>
                <Dialog
                  open={leaveSummaryDialog.open}
                  onClose={closeLeaveSummaryDialog}
                  maxWidth="xs"
                  fullWidth
                  PaperProps={{
                    style: {
                      borderRadius: "16px",
                      padding: "0",
                      background: darkMode ? '#1e1e2e' : '#ffffff',
                      boxShadow: darkMode ? '0 8px 32px rgba(0,0,0,0.4)' : '0 8px 32px rgba(3, 109, 218, 0.15)',
                    }
                  }}
                >
                  <DialogTitle style={{
                    background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                    color: "white",
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: "bold",
                    position: "relative",
                    minHeight: "36px",
                    padding: "8px 0 8px 0",
                    lineHeight: 1.2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    {leaveSummaryDialog.title}
                    <CloseIcon
                      style={{
                        position: "absolute",
                        top: 8,
                        right: 10,
                        cursor: "pointer",
                        color: "#fff",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "50%",
                        padding: "2px",
                        width: 28,
                        height: 28,
                        transition: "background-color 0.2s"
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.3)"}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.2)"}
                      onClick={closeLeaveSummaryDialog}
                    />
                  </DialogTitle>
                  <DialogContent style={{ padding: "24px", background: darkMode ? '#1e1e2e' : '#ffffff' }}>
                    {leaveSummaryDialog.details.length > 0 ? (
                      leaveSummaryDialog.details.map((detail, index) => (
                        <Typography
                          key={`${leaveSummaryDialog.title}-${index}`}
                          style={{
                            fontSize: '0.95rem',
                            lineHeight: 1.6,
                            color: darkMode ? '#ffffff' : '#2f3d46',
                            marginBottom: index === leaveSummaryDialog.details.length - 1 ? 0 : 8,
                          }}
                        >
                          {detail}
                        </Typography>
                      ))
                    ) : (
                      <Typography style={{ fontSize: '0.95rem', color: darkMode ? '#ffffff' : '#2f3d46' }}>
                        No details available.
                      </Typography>
                    )}
                  </DialogContent>
                </Dialog>
                <Box width="100%" style={{ marginTop: '20px', marginBottom: "40px" }}>
                  <TableComponent
                    {...props}
                    tableTh={leaveBalanceHeaders}
                    tableData={leaveBalanceTableData}
                    tableCount={filteredLeaveBalanceData.length}
                    isLoading={leaveBalanceLoading}
                    colNameToShow={[
                      'emp_id',
                      'firstName',
                      'month',
                      'paid_leave_allowed',
                      'paid_leave_used',
                      'carry_forward',
                      'carry_forward_details'
                    ]}
                    openPopUp={false}
                    actionBtns={null}
                    modelName={"Leave Balance"}
                    orderBy="month"
                    order="asc"
                    page={leaveBalancePage}
                    rowsPerPage={pageSize}
                    onPageChange={(newPage) => setLeaveBalancePage(newPage)}
                    onRowsPerPageChange={(event) => {
                      setPageSize(parseInt(event.target.value, 10));
                      setLeaveBalancePage(0);
                    }}
                    extraHeaderContent={leaveBalanceHeaderControls}
                    shellClassName="holiday-table-shell"
                  />
                </Box>
              </TabPanel>
              {
                Pdf && (
                  <Dialog
                    open={Pdf}
                    onClick={() => setPdf(false)}
                    style={{ marginTop: "35px" }}
                  >
                    <DialogTitle>Salary Slip</DialogTitle>
                    <DialogContent>
                      {slip && (
                        <iframe title="Salary Slip" src={slip} width="100%" height="500px" />
                      )}
                    </DialogContent>
                  </Dialog>
                )
              }
            </div >
          </div >
        }
      />
      < Footer {...props} />
    </div >
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box pt={3} pb={3} px={0}>{children}</Box>}
    </div>
  );
}

export default UserDetails;
